import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { YearService } from '../../../shared-components/year/year.service';
import { Observable } from 'rxjs';
import { System } from '../../../shared-components/System';
import { Team } from '../../../student360/teams/team.model';
import { StaffCardPreferences } from './staff-card-settings/staff-card-preferences.model';
import { EFormInstance } from '../../../shared-components/e-forms/e-form-instance.model';
import * as moment from 'moment';
import { Student } from '../../../shared-components/student/student.model';
import { StaffWork } from './staff-work-card/staff-work.model';

@Injectable()
export class StaffCardsService {

    cardPreferences: StaffCardPreferences;
    surveyCardShowCountsForAllSchools = false;
    SurveyCardGetMostRecent = false;
    hideEmptyAlerts = false;
    SurveyCardStartDateByDate: moment.Moment;
    SurveyCardStartDateByRange: moment.Moment;
    rightContainerHeight: number;

    constructor(
        private http: HttpClient,
        private yearService: YearService,
    ) {
    }

    getAbsencesByCourseCard(numberOfAbsences: number, absentType: number = 0): Observable<any[]> {
        return this.http.get<any[]>(System.apiURL.Classroom + 'GetAbsenceByCourseCard?yearId=' + this.yearService.defaultYear.Id + '&siteId=' + this.yearService.defaultYear.SchoolID + '&numberOfAbsences=' + numberOfAbsences + '&absentType=' + absentType);
    }

    getRecentBehaviorCard(date): Observable<any[]> {
        return this.http.get<any[]>(System.apiURL.Classroom + 'GetRecentBehaviorCard?yearId=' + this.yearService.defaultYear.Id + '&siteId=' + this.yearService.defaultYear.SchoolID + '&date=' + date);
    }

    getStaffTeamsCard(): Observable<Team[]> {
        return this.http.get<Team[]>(System.apiURL.Classroom + 'GetStaffTeamsCard?yearId=' + this.yearService.defaultYear.Id + '&siteId=' + this.yearService.defaultYear.SchoolID);
    }

    getSchoolsTodayCard(fromDate: string, toDate: string, siteYearId: number = 0, includeProjected: boolean = false): Observable<any[]> {
        return this.http.get<any[]>(System.apiURL.Classroom + 'GetSchoolsTodayCard?yearId=' + this.yearService.defaultYear.Id + '&fromDate=' + fromDate + '&toDate=' + toDate + '&siteYearId=' + siteYearId + '&includeProjected=' + includeProjected);
    }

    getProgramEnrollmentCard(days: number = 0): Observable<any[]> {
        return this.http.get<any[]>(System.apiURL.Classroom + 'GetProgramEnrollmentCard?yearId=' + this.yearService.defaultYear.Id + '&siteId=' + this.yearService.defaultYear.SchoolID + '&days=' + days);
    }

    getStaffWorkCard(): Observable<StaffWork> {
        return this.http.get<StaffWork>(System.apiURL.Classroom + 'GetStaffWorkCard?yearId=' + this.yearService.defaultYear.Id + '&siteId=' + this.yearService.defaultYear.SchoolID);
    }

    getEFormSurveysForStaffCard(yearId: number, schoolId: number, showCountsForAllSchools: boolean, getMostRecent: boolean, startDate: string): Observable<EFormInstance[]> {
        const queryString = '?yearId=' + yearId +
            '&schoolId=' + schoolId +
            '&showCountsForAllSchools=' + showCountsForAllSchools +
            '&getMostRecent=' + getMostRecent +
            '&startDate=' + startDate;
        return this.http.get<EFormInstance[]>(System.apiURL.Admin + 'GetEFormSurveysForStaffCard' + queryString);
    }

    getUpcomingBirthdaysCard(numberOfDays: number = 0) {
        return this.http.get<Student[]>(System.apiURL.Classroom + 'GetUpcomingBirthdaysCard?yearId=' + this.yearService.defaultYear.Id + '&siteId=' + this.yearService.defaultYear.SchoolID + '&numberOfDays=' + numberOfDays);
    }

    getRecentlyUpdatedGBGradesCard(days: number = 0): Observable<any[]> {
        return this.http.get<any[]>(System.apiURL.Classroom + 'GetRecentlyUpdatedGBGradesCard?yearId=' + this.yearService.defaultYear.Id + '&siteId=' + this.yearService.defaultYear.SchoolID + '&days=' + days);
    }

    getImmunizationComplianceCard(showAllSchoolCounts: boolean): Observable<any[]> {
        return this.http.get<any[]>(System.apiURL.Classroom + 'GetImmunizationComlianceCard?yearId=' + this.yearService.defaultYear.Id + '&siteId=' + this.yearService.defaultYear.SchoolID + '&showAllSchoolCounts=' + showAllSchoolCounts);
    }
}